import React from 'react'
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export default class Bilhete extends React.Component {

  getBadgeVariant(situacao) {
    if (!situacao) return 'default';
    if (situacao === 'CONFIRMADO' || situacao === 'APROVADO') return 'confirmado';
    if (situacao === 'CANCELADO' || situacao === 'CANCELADO_REEMBOLSO_EFETUADO') return 'cancelado';
    if (situacao === 'PENDENTE') return 'pendente';
    if (situacao === 'REEMBOLSO_SOLICITADO') return 'reembolso';
    if (situacao === 'EM_ABERTO') return 'aberto';
    if (situacao === 'REMARCADO') return 'remarcado';
    return 'default';
  }

  render() {
    if (!this.props.reserva) {
      return null
    }
    const { reserva } = this.props
    const disabled = !reserva.sePodeRemarcarOuCancelar

    return (
      <div
        className={`vx-row-item${disabled ? ' vx-row-item--disabled' : reserva.selecionada ? ' vx-row-item--selected' : ''}`}
        onClick={disabled ? undefined : () => this.props.alterarMarcacaoReserva(reserva)}
        style={{cursor: disabled ? 'default' : 'pointer'}}
      >
        <div className="vx-row-item-inner vx-row-item-inner--bilhete">
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Empresa</div>
            {capitalizarTodasPrimeirasLetras(reserva.nomeEmpresa)}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Nome</div>
            {capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">CPF</div>
            {reserva.passageiroDto.cpfPassageiro}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Data embarque</div>
            {reserva.dataHoraPartida || '-'}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Origem / Destino</div>
            {reserva.descCidadeOrigem} / {reserva.descCidadeDestino}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Delimitação</div>
            {reserva.delimitacao}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Embarcou</div>
            {reserva.dataHoraEmbarque || 'Não embarcou'}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Situação</div>
            <span className={`vx-remark-badge vx-remark-badge--${this.getBadgeVariant(reserva.situacaoReserva)}`}>
              {capitalizarTodasPrimeirasLetras(reserva.situacaoReserva.replace(/_/g, ' '))}
            </span>
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Pedido</div>
            {reserva.pedidoId}
          </div>
          <div className="vx-row-cell">
            <div className="vx-row-cell-label">Poltrona</div>
            {reserva.numeroPoltrona}
          </div>
        </div>
      </div>
    )
  }
}
